import { Box, BoxProps, Grid, Skeleton, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const CardContainer = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  borderRadius: '0.375rem',
  boxShadow: '0px 5px 12px 0px rgba(0, 0, 0, 0.08)',
}));
interface CounterCardProps {
  icon: React.JSX.Element;
  label: string;
  value: string | number;
  isLoading: boolean;
}
function CounterCard({ icon, label, value, isLoading }: CounterCardProps) {
  const theme = useTheme();
  return (
    <Grid item xl={3} md={3} xs={6} sx={{ paddingBottom: '2rem' }}>
      <CardContainer>
        <Typography sx={{ lineHeight: 'normal', color: theme.palette.text.disabled }}>{label}</Typography>
        <Typography
          sx={{
            fontSize: '2.25rem',
            lineHeight: 'normal',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '0.438rem 0',
          }}
        >
          {isLoading ? (
            <Skeleton width={50} />
          ) : (
            <>
              {icon}
              <Box sx={{ paddingLeft: '0.75rem' }}>{value}</Box>
            </>
          )}
        </Typography>
      </CardContainer>
    </Grid>
  );
}

export default CounterCard;
